import { render, staticRenderFns } from "./pubcars.vue?vue&type=template&id=4356cc72&scoped=true"
import script from "./pubcars.vue?vue&type=script&lang=js"
export * from "./pubcars.vue?vue&type=script&lang=js"
import style0 from "./pubcars.vue?vue&type=style&index=0&id=4356cc72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356cc72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4356cc72')) {
      api.createRecord('4356cc72', component.options)
    } else {
      api.reload('4356cc72', component.options)
    }
    module.hot.accept("./pubcars.vue?vue&type=template&id=4356cc72&scoped=true", function () {
      api.rerender('4356cc72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/pubcars.vue"
export default component.exports